import { QueryObserverOptions } from 'react-query';

import { AxiosRequestConfig } from 'axios';
import { useEntityMany } from 'requests/resources/makeResources/queries';

import { keys } from '../keys';

type TPreviewCheckOptions = {
  page: number;
  size: number;
  response: any;
};

export default function useLumaBotPreviewCheck(
  params?: AxiosRequestConfig['params'],
  options?: QueryObserverOptions<TPreviewCheckOptions>,
) {
  return useEntityMany<TPreviewCheckOptions>(keys.many, '/lumabot/preview/check', params, options);
}
